/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_Ship_ToInputs */

const en_po_field_ship_to = /** @type {(inputs: Po_Field_Ship_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ship to`)
};

/**
* | output |
* | --- |
* | "Ship to" |
*
* @param {Po_Field_Ship_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_ship_to = /** @type {((inputs?: Po_Field_Ship_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_Ship_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_ship_to(inputs)
});